import { FormControlLabel, FormGroup, Switch as MUISwitch, Typography } from "@material-ui/core";
import firebase from "firebase";
import { useEffect, useState } from "react";
import { Nav, Navbar, Spinner, Card, Table } from "react-bootstrap";
import { Alert } from "@mui/material"
import { LinkContainer } from "react-router-bootstrap";
import {
    BrowserRouter as Router, Route, Switch, useParams, useRouteMatch
} from "react-router-dom";
import { db } from '../../../firebase';
import Match from "./match";

/*
@params DAY MATCH RUBBER 
    1. Display all MATCHes on this date
    2. Each MATCH consists all results between 2 teams
    3. Each RUBBER contains all results of 2 oppositions e.g. if A and B play 5 sets, results of all 5 sets will go into the same RUBBER
*/
export default function Day(props) {
    let { id } = useParams()
    let routeMatch = useRouteMatch()

    let [allMatches, setallMatches] = useState([])
    let [loading, setLoading] = useState(true)
    let [checked, setchecked] = useState(false)
    let [myappuser, setmyappuser] = useState({})
    let [availablePlys, setavailablePlys] = useState([])


    let matchesDBRef = db.collection("seasons").doc(props.seasonID)
        .collection("days").doc(id).collection("matches")

    let dayDBRef = db.collection("seasons").doc(props.seasonID)
        .collection("days").doc(id)

    let myAvailabilityDBRef = dayDBRef
        .collection("availability").doc(firebase.auth().currentUser.uid)

    let availabilityDBRef = dayDBRef.collection("availability")

    let appuserDBRef = db.collection("appusers").doc(firebase.auth().currentUser.uid)

    // player availability
    function handleChangeAvailability(event) {
        // add player info to availability
        console.log(myappuser)
        if (event.target.checked) {
            myAvailabilityDBRef.set(myappuser)
                .then(() => {
                    console.log("player availability set")
                    setchecked(true)
                })
                .catch((e) => { console.log(e) })
        }
        // remove player info from availability
        else {
            myAvailabilityDBRef.delete()
                .then(() => {
                    console.log("Document successfully deleted!");
                    setchecked(false)
                }).catch((error) => {
                    console.error("Error removing document: ", error);
                })
        }
    }

    function getAvailability() {
        myAvailabilityDBRef.get()
            .then((doc) => {
                if (doc.exists) {
                    setchecked(true)
                }
                else {
                    setchecked(false)
                }
            })
            .catch((error) => {
                console.log("Error getting player availability:", error);
            })
    }

    function getAllMatches() {
        setLoading(true)
        matchesDBRef.get()
            .then((querySnapshot) => {
                var resMatches = []
                querySnapshot.forEach((doc) => {
                    let matchObj = doc.data()
                    matchObj.id = doc.id
                    resMatches.push(matchObj)
                })
                resMatches = sortMatches(resMatches)
                console.log(resMatches)
                setallMatches(resMatches)
                setLoading(false)
            })
            .catch((e) => {
                console.log(e)
                setLoading(false)
            })
    }

    function sortMatches(days) {
        days.sort(function (a, b) {
            // Turn your strings into dates, and then subtract them
            // to get a value that is either negative, positive, or zero.
            return new Date(b.date) - new Date(a.date);
        });
        return days
    }

    function getMyAppuser() {
        appuserDBRef.get()
            .then((doc) => {
                if (doc.exists) {
                    console.log("appuser:", doc.data());
                    const appuser = {
                        displayName: doc.data().displayName,
                        email: doc.data().email,
                        uid: doc.data().uid
                    }
                    setmyappuser(doc.data())
                } else {
                    // doc.data() will be undefined in this case
                    console.log("No such document!");
                }
            })
            .catch((e) => { console.log(e) })
    }

    // available players
    function getavailablePlys() {
        availabilityDBRef.get()
            .then((querySnapShot) => {
                var newplayerPool = []
                querySnapShot.forEach((doc) => {
                    let data = doc.data()
                    var player = {
                        displayName: data.displayName,
                        uid: data.uid,
                        id: doc.id,
                    }
                    newplayerPool.push({ player })
                })
                console.log("player pool: ", newplayerPool)
                setavailablePlys(newplayerPool)
            })
            .catch((e) => {
                console.log(e)
            })
    }

    useEffect(() => {
        getAllMatches()
        getMyAppuser()
        getAvailability()
        getavailablePlys()
    }, [id])

    useEffect(() => {
        getavailablePlys()
    }, [checked])

    const displayMatches = (
        allMatches.map((m, ind) => {
            return (
                <div key={ind}>
                    <LinkContainer to={`${routeMatch.url}/matches/${m.id}`}>
                        <Nav.Link>
                            <b>{m.name}</b>
                            <br></br>
                            <span>{m.time}</span>
                        </Nav.Link>
                    </LinkContainer>

                </div>
            )
        })
    )

    const displayAvailablePlys = availablePlys.map((player, ind) => {
        return (
            <tr>
                <td>{player.player.displayName}</td>
            </tr>
        )
    })

    const displayDay = (
        <div className="flex-column">

            <Alert severity="warning">
                <p>Please note: the capacity for one time slot is 12 players. You may not have a guaranteed spot every week if more people sign up, so please check the matches down below before you arrive.</p>
                {/* <p>The number beside the player list doesn't indicate the order you will be placed in the team.</p> */}
            </Alert>

            <div className="flex">
                <Card className="toggle-button">
                    <Card.Body>
                        <FormGroup column>
                            <FormControlLabel
                                control={
                                    <MUISwitch
                                        checked={checked}
                                        onChange={handleChangeAvailability}
                                        color="primary"
                                    />
                                }
                                label={checked ? "Available" : "Not available"}
                            />
                        </FormGroup>
                    </Card.Body>
                </Card>

                <Card className="player-table-container">
                    <Card.Body>
                        <Table striped bordered hover size="sm">
                            <thead>
                                <tr>
                                    <th>Available Players</th>
                                </tr>
                            </thead>
                            <tbody>
                                {displayAvailablePlys}
                            </tbody>
                        </Table>
                    </Card.Body>
                </Card>


            </div>

            <Navbar
                variant="dark"
                className="navbar"
            >
                <h5 className="light-text">Matches</h5>
                <Nav className='side-bar-1'>
                    {displayMatches}
                </Nav>
            </Navbar>
        </div>
    )

    return (
        <div>
            <Router>
                {loading ? <Spinner animation="border" role="status">
                    <span className="sr-only">Loading...</span>
                </Spinner> : displayDay}
                <Switch>
                    <Route path={`${routeMatch.url}/matches/:id`}>
                        <Match seasonID={props.seasonID} dayID={id} reloadMatches={getAllMatches} />
                    </Route>
                </Switch>
            </Router>
        </div>
    )

}
